import React from 'react'
import { Grid, Icon } from 'semantic-ui-react';
import Labels from './../../../../common/Labels';
import { source } from 'react-aim';
import { dispatch } from '@rematch/core';
import convertIcon from '../../../../../helpers/convert-Icon';
import contentURL from '../../../../../helpers/contentURL'
@source({
    mouseEnter: (props, component) => {
        dispatch.app.setHelpContext('Details Card');
    }
})
class Detail extends React.Component {
    goToLink(event, data) {
        let redirectUrl = data.contentpath.indexOf('://') === -1 ? 'http://' + data.contentpath : data.contentpath
        window.open(redirectUrl, '_blank');
    }

    render() {
        const { selectedContent } = this.props;

        return (
            <Grid columns={4} >
                <Grid.Row>
                    <Grid.Column width={16}>
                        {contentURL(selectedContent.contentpath, selectedContent.type)} <br /><br />

                        <Labels
                            name="Content Author"
                            text={selectedContent.contentAuthor && selectedContent.contentAuthor.length !== 0 ? selectedContent.contentAuthor : "NA"} />
                    </Grid.Column>

                </Grid.Row>
            </Grid>
        )
    }
}

export default Detail